var waves = [
    {
        "totalWaveCount": 50,
        "tankCount": 0,
        // must change these spawn rates into something higher based on spawnInterval convertion rates with respect to unity
        "spawnRate": 1.6,
        "onTrafficCount": {
            "buggy": [15, 30],
            "battleTruck": [-1],
            "tank": [-1],
            "obstacle": [7],
            "missile": [10],
            "ambulance": [20, 40]
        },
        "spawnInterval": {
            "min": 0.45,
            "max": 0.55,
        }
    },
    {
        "totalWaveCount": 50,
        "tankCount": 0,
        "spawnRate": 1.5,
        "onTrafficCount": {
            "buggy": [10, 20, 30],
            "battleTruck": [40],
            "tank": [-1],
            "obstacle": [7, 21, 36],
            "missile": [15, 35],
            "ambulance": [35, 45]
        },
        "spawnInterval": {
            "min": 0.3,
            "max": 0.45,
        }
    },
    {
        "totalWaveCount": 75,
        "tankCount": 1,
        "spawnRate": 1.2,
        "onTrafficCount": {
            "buggy": [20, 40, 60],
            "battleTruck": [50],
            "tank": [74],
            "obstacle": [7, 21, 36, 50],
            "missile": [13, 33, 53],
            "ambulance": [22, 45, 70]
        },
        "spawnInterval": {
            "min": 0.25,
            "max": 0.3,
        }
    },
    {
        "totalWaveCount": 100,
        "tankCount": 1,
        "spawnRate": 1,
        "onTrafficCount": {
            "buggy": [10, 20, 40, 50],
            "battleTruck": [30, 70],
            "tank": [60, 90],
            "obstacle": [15, 25, 35, 65, 75, 85],
            "missile": [11, 31, 51, 71],
            "ambulance": [25, 55, 65, 95]
        },
        "spawnInterval": {
            "min": 0.2,
            "max": 0.25,
        }
    },
]
export default waves;